import { Skeleton } from "../ui/skeleton";

export default function MyStacksSkeleton() {
  return (
    <div className="bg-white rounded-lg p-6 space-y-4">
      <div className="flex items-center gap-3">
        <Skeleton className="h-10 w-12 rounded-full bg-gray-300" />
        <div className="flex justify-between items-center w-full gap-2">
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-24 bg-gray-300" />
            <Skeleton className="h-4 w-16 bg-gray-300" />
          </div>
          <Skeleton className="h-8 w-8 rounded-full bg-gray-300" />
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="space-y-2">
          <Skeleton className="h-4 w-28 bg-gray-300" />
          <Skeleton className="h-4 w-24 bg-gray-300" />
        </div>
        <div className="space-y-2">
          <Skeleton className="h-4 w-28 bg-gray-300" />
          <Skeleton className="h-4 w-24 bg-gray-300" />
        </div>
        <div className="space-y-2 hidden md:block">
          <Skeleton className="h-4 w-28 bg-gray-300" />
          <Skeleton className="h-4 w-24 bg-gray-300" />
        </div>
      </div>
      <Skeleton className="h-6 w-32 bg-gray-300" />
      <div className="flex items-center gap-2">
        <Skeleton className="h-8 w-1/2 bg-gray-300" />
        <Skeleton className="h-8 w-1/2 bg-gray-300" />
      </div>
    </div>
  );
}
